import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import Container from '@mui/material/Container'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import CircularProgress from '@mui/material/CircularProgress'
import { getData } from '../api/indexedDBHandler'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Alert from '@mui/material/Alert'
import { updateData, addRequestsData } from '../api/indexedDBHandler'
import Box from '@mui/material/Box'
import CompetitionSelectWinners from './Components/CompetitionSelectWinners'
import CompetitionDuration from './Components/CompetitionDuration'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import TournamentName from './Components/TournamentName'
import CompetitionDate from './Components/CompetitionDate'
import WaterBody, { findLabelByValue } from './Components/WaterBody'
import TournamentLogoUploader from './Components/TournamentLogoUploader'
import CompetitionType from './Components/CompetitionType'
import CompetitionFormatted from './Components/CompetitionFormatted'
import CompetitionDraw from './Components/CompetitionDraw'
import CompetitionProtocols from './Components/CompetitionProtocols'
import CompetitionDopNomination from './Components/CompetitionDopNomination'
import Button from '@mui/material/Button'
import { formatDateToDDMMYYYY } from '../api/formatDate'
import { useNavigate } from 'react-router-dom'
import DopProtocol from './Components/DopProtocol'
import { useSnackbar } from '../alert/SnackbarProvider'
import CompetitionPaid from './Components/CompetitionPaid'
import CompetitonStep from './Components/CompetitonStep'

const TournamentSettings = () => {
  const { id } = useParams()
  const tournamentNameRef = useRef(null)
  const competitionDurationRef = useRef(null)
  const competitionDateRef = useRef(null)
  const [tournament, setTournament] = useState(null)
  const tournamentLogoUploaderRef = useRef(null)
  const competitionTypeRef = useRef(null)
  const competitionFormattedRef = useRef(null)
  const competitionDrawRef = useRef(null)
  const competitionSelectWinnersRef = useRef(null)
  const waterBodyRef = useRef(null)
  const competitionProtocolsRef = useRef(null)
  const competitionDopNominationRef = useRef(null)
  const settingProtocolRef = useRef(null)
  const navigate = useNavigate()
  const [oneProtocol, setOneProtocol] = React.useState(true)
  const [loading, setLoading] = useState(false)
  const showSnackbar = useSnackbar()

  const paidRef = useRef(null)
  const type_paidRef = useRef(null)
  const sum_paid_1Ref = useRef(null)
  const sum_paid_2Ref = useRef(null)

  useEffect(() => {
    const getTournament = async () => {
      const results = await getData('tournaments', 'id', id)
      if (results.length > 0) {
        const { value } = results[0]
        console.log('value', value)
        setTournament(value)
      }
    }
    getTournament()
  }, [id])

  useEffect(() => {
    if (!tournament) return
    const regexWeighing = /(Главный судья|Организатор)/i

    if (!regexWeighing.test(tournament.roles)) {
      navigate('/')
    }
    if (tournament.winners.length > 1) setOneProtocol(false)
    else setOneProtocol(true)
  }, [tournament])

  // const count_sportsmensRef = useRef(null)
  // const type_paidRef = useRef(null)
  // const sum_paid_1Ref = useRef(null)
  // const sum_paid_2Ref = useRef(null)
  const buttonEditPaid = async () => {
    setLoading(true)

    const isFormValid = paidRef.current.validate()
    if (isFormValid) {
      const {
        value_sum_paid_1,
        value_sum_paid_2,
        value_count_sportsmens,
        value_type_paid,
      } = paidRef.current.val()

      const update_data = {
        do: 'paid',
        sum_paid_1: value_sum_paid_1 != '' ? value_sum_paid_1 : null,
        sum_paid_2: value_sum_paid_2 != '' ? value_sum_paid_2 : null,
        count_sportsmens: value_count_sportsmens,
        type_paid: value_type_paid,
        cup_id: id,
        requestKey: `${id}_updateTournaments_${new Date().getTime()}`,
      }

      //   const requestKey = `${id}_dellUser_${new Date().getTime()}`
      //  requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      await updateData('tournaments', id, {
        ...update_data,
      })
      try {
        await addRequestsData('requests', {
          url: 'tournaments/updateTournaments.php',
          ...update_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 2000))
      } catch (error) {
        showSnackbar('Ошибка сохранения', 'error')
      } finally {
        setLoading(false)
        showSnackbar('Данные сохранены', 'success')
      }
    }
    setLoading(false)
  }
  const buttonEditType = async () => {
    setLoading(true)

    const isCompetitionTypeValid = competitionTypeRef.current.validate()
    const isCompetitionFormattedValid =
      competitionFormattedRef.current.validate()
    const isCompetitionDrawValid = competitionDrawRef.current.validate()
    const isCompetitionSelectWinnersValid =
      competitionSelectWinnersRef.current.validate()
    const isCompetitionProtocolsValid = oneProtocol
      ? true
      : competitionProtocolsRef.current.validate()

    const isFormValid =
      isCompetitionTypeValid &&
      isCompetitionFormattedValid &&
      isCompetitionDrawValid &&
      isCompetitionSelectWinnersValid &&
      isCompetitionProtocolsValid
    if (isFormValid) {
      const update_data = {
        do: 'type',
        competition_type: competitionTypeRef.current.val(),
        competition_format: competitionFormattedRef.current.val(),
        tournament_draw: competitionDrawRef.current.val(),
        winners: competitionSelectWinnersRef.current.val(),
        protocols: !oneProtocol
          ? competitionProtocolsRef.current.val()
          : 'Отдельные протоколы',
        dop_nomination: competitionDopNominationRef.current.val(),
        requestKey: `${id}_updateTournaments_${new Date().getTime()}`,
        cup_id: id,
      }
      //   const requestKey = `${id}_dellUser_${new Date().getTime()}`
      //  requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      await updateData('tournaments', id, {
        ...update_data,
      })

      try {
        await addRequestsData('requests', {
          url: 'tournaments/updateTournaments.php',
          ...update_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 2000))
      } catch (error) {
        showSnackbar('Ошибка сохранения', 'error')
      } finally {
        setLoading(false)
        showSnackbar('Данные сохранены', 'success')
      }
    } else setLoading(false)
  }
  const buttonEditOsn = async () => {
    setLoading(true)

    const isTournamentNameValid = tournamentNameRef.current.validate()
    const isCompetitionDateValid = competitionDateRef.current.validate()
    const isCompetitionDurationValid = competitionDurationRef.current.validate()
    const isWaterBodyValid = waterBodyRef.current.validate()

    const isFormValid =
      isCompetitionDateValid &&
      isTournamentNameValid &&
      isCompetitionDurationValid &&
      isWaterBodyValid

    if (isFormValid) {
      const update_data = {
        do: 'osn',
        tournament_name: tournamentNameRef.current.val(),

        start_date: formatDateToDDMMYYYY(
          competitionDateRef.current.val().startDate
        ),
        end_date: formatDateToDDMMYYYY(
          competitionDateRef.current.val().endDate
        ),
        cup_id: id,
        duration: competitionDurationRef.current.val(),
        water_id: waterBodyRef.current.val(),
        water_body: findLabelByValue(waterBodyRef.current.val()),
        requestKey: `${id}_updateTournaments_${new Date().getTime()}`,
      }
      // const requestKey = `${id}_dellUser_${new Date().getTime()}`
      // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      await updateData('tournaments', id, {
        ...update_data,
      })

      try {
        await addRequestsData('requests', {
          url: 'tournaments/updateTournaments.php',
          ...update_data,
        })
        await new Promise((resolve) => setTimeout(resolve, 2000))
      } catch (error) {
        showSnackbar('Ошибка сохранения', 'error')
      } finally {
        setLoading(false)
        showSnackbar('Данные сохранены', 'success')
      }
    } else setLoading(false)
  }

  if (tournament)
    return (
      <Container sx={{ mb: 15 }}>
        <div role="presentation" style={{ textAlign: 'left', width: '100%' }}>
          <Breadcrumbs maxItems={2} aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/tournaments-list">
              Турниры
            </Link>
            <Link underline="hover" color="inherit" href={'/tournaments/' + id}>
              Редактирование
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Настройки</Typography>
          </Breadcrumbs>
        </div>
        <Typography variant="h6" gutterBottom color="black" sx={{ mt: 2 }}>
          {tournament.tournament_name}
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          Изменения в этом разделе требуют наличия соединения с интернетом.
        </Alert>

        <Grid container spacing={2} style={{ width: '100%' }}>
          <Grid size={{ xs: 12 }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel2-content"
                id="settings_info"
              >
                <Typography
                  component="span"
                  sx={{ width: '33%', flexShrink: 0 }}
                >
                  Основные
                </Typography>
                <Typography component="span" sx={{ color: 'text.secondary' }}>
                  Название, водоём, логотип, продолжительность
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  mt={1}
                  sx={{
                    width: '100%',
                    display: 'grid',
                    gap: 1,
                  }}
                >
                  <TournamentName
                    ref={tournamentNameRef}
                    defaultTournamentName={tournament.tournament_name}
                  />
                  <CompetitionDate
                    ref={competitionDateRef}
                    defaultstartDate={tournament.start_date}
                    defaultendDate={tournament.end_date}
                  />
                  <CompetitionDuration
                    ref={competitionDurationRef}
                    defaultvar={tournament.duration + ''}
                  />
                  <WaterBody
                    ref={waterBodyRef}
                    defaultvar={tournament.water_id + ''}
                  />
                  <TournamentLogoUploader
                    ref={tournamentLogoUploaderRef}
                    initialLogoUrl={tournament.logocup}
                    tournamentId={tournament.id}
                  />
                </Box>
                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={buttonEditOsn}
                    disabled={loading}
                    startIcon={loading && <CircularProgress size={20} />}
                  >
                    {loading ? 'Загрузка...' : 'Сохранить изменения'}
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography
                  component="span"
                  sx={{ width: '33%', flexShrink: 0 }}
                >
                  Формат
                </Typography>
                <Typography component="span" sx={{ color: 'text.secondary' }}>
                  Определение победителя, тип, жеребьёвка, статус, номинации
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  mt={1}
                  sx={{
                    width: '100%',
                    display: 'grid',
                    gap: 1,
                  }}
                >
                  <CompetitionType
                    ref={competitionTypeRef}
                    defaultvar={tournament.competition_type}
                  />
                  <CompetitionFormatted
                    ref={competitionFormattedRef}
                    defaultvar={tournament.competition_format}
                  />

                  <CompetitionDraw
                    ref={competitionDrawRef}
                    defaultvar={tournament.tournament_draw}
                  />
                  <CompetitionSelectWinners
                    ref={competitionSelectWinnersRef}
                    defaultvar={tournament.winners}
                    setOneProtocol={setOneProtocol}
                  />
                  {!oneProtocol && (
                    <CompetitionProtocols
                      ref={competitionProtocolsRef}
                      defaultvar={tournament.protocols}
                    />
                  )}
                  <CompetitionDopNomination
                    ref={competitionDopNominationRef}
                    defaultvar={tournament.dop_nomination}
                  />
                </Box>
                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={buttonEditType}
                    disabled={loading}
                    startIcon={loading && <CircularProgress size={20} />}
                  >
                    {loading ? 'Загрузка...' : 'Сохранить изменения'}
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography
                  component="span"
                  sx={{ width: '33%', flexShrink: 0 }}
                >
                  Взносы
                </Typography>
                <Typography component="span" sx={{ color: 'text.secondary' }}>
                  Сумма взносов может быть настроена по количеству спортсменов.
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  mt={1}
                  sx={{
                    width: '100%',
                    display: 'grid',
                    gap: 1,
                  }}
                >
                  <CompetitionPaid
                    ref={paidRef}
                    default_count_sportsmens={tournament.count_sportsmens}
                    default_type_paid={tournament.type_paid}
                    default_sum_paid_1={tournament.sum_paid_1}
                    default_sum_paid_2={tournament.sum_paid_2}
                  />
                </Box>

                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={buttonEditPaid}
                    disabled={loading}
                    startIcon={loading && <CircularProgress size={20} />}
                  >
                    {loading ? 'Загрузка...' : 'Сохранить изменения'}
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
          {/* <Grid size={{ xs: 12, md: 12 }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography
                  component="span"
                  sx={{ width: '33%', flexShrink: 0 }}
                >
                  Спростмены
                </Typography>
                <Typography component="span" sx={{ color: 'text.secondary' }}>
                  Допуск спортсмена по разряду, количество спортсменов,
                  требуемый пакет документов.
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DopProtocol />
                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button variant="contained" color="success">
                    Сохранить изменения
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid> */}
          <Grid size={{ xs: 12, md: 12 }}>
            <CompetitonStep ref={competitionDrawRef} defaultvar={tournament} />
          </Grid>

          {/* 
          <Grid size={{ xs: 12, md: 12 }}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography
                  component="span"
                  sx={{ width: '33%', flexShrink: 0 }}
                >
                  Дополнительные протоклы
                </Typography>
                <Typography component="span" sx={{ color: 'text.secondary' }}>
                  Карта взвешивания, протокол взвешивания
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <DopProtocol />
                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button variant="contained" color="success">
                    Сохранить изменения
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid> */}
        </Grid>
      </Container>
    )
}
export default TournamentSettings
